import { useTranslation } from 'react-i18next';
import useValidations from 'hooks/useValidations';
import { useMemo } from 'react';
import { useApp } from 'contexts/App';

export default function useValidationSchema() {
  const { t } = useTranslation('CreateOrder');
  const { createSchema } = useValidations();

  const {
    state: { isGroupUser },
  } = useApp();

  return useMemo(() => {
    const fields = [
      {
        type: 'string',
        label: '',
        ruleName: 'internalOrderId',
      },
      {
        type: 'customer',
        label: t('CustomerDetails.labels.accountNumber'),
      },
      ...(!isGroupUser
        ? [
            {
              type: 'representative',
              label: t('CustomerDetails.labels.representativeAccount'),
            },
          ]
        : []),
      {
        type: 'requiredString',
        ruleName: 'officeLocation',
        label: t('CustomerDetails.labels.officeLocation'),
      },
      {
        type: 'string',
        label: t('CustomerDetails.labels.notes'),
        ruleName: 'customerNotes',
      },
      {
        type: 'string',
        ruleName: 'multiAccount',
        label: t('CustomerDetails.labels.multiAccount'),
      },
      {
        type: 'string',
        ruleName: 'debtOwner',
        defaultValue: 'false',
        label: '',
      },
    ];
    return createSchema(fields);
  }, [createSchema, isGroupUser, t]);
}
